module.exports = __webpack_public_path__ + "./images/b32ac11220a8cfa9312afa145bfb52c1.webp";